import { SegmentOption } from '@shared/components/segmented-control/segmented-control.models'
import { AggregationSelectable } from '../models/aggregations.models'

export const AGGREGATIONS_FEATURE_TOKEN = 'aggregations'

export const AGGREGATIONS_COLUMN_OPTIONS: SegmentOption[] = [
  {
    id: 'left',
    label: 'MTR_LEFT_COLUMN'
  },
  {
    id: 'right',
    label: 'MTR_RIGHT_COLUMN'
  }
]

export const AGGREGATIONS_AVERAGE_SELECTABLE_MODE: AggregationSelectable = {
  id: 'Average',
  text: 'MTR_COMMON_AVERAGE'
}

export const AGGREGATIONS_COMPETITION_AVERAGE_SELECTABLE_MODE: AggregationSelectable = {
  id: 'CompetitionAverage',
  text: 'MTR_COMMON_AVERAGE_COMPETITION'
}

export const AGGREGATIONS_ACCUMULATED_SELECTABLE_MODE: AggregationSelectable = {
  id: 'Accumulated',
  text: 'MTR_COMMON_ACCUMULATED'
}
export const AGGREGATIONS_MATCH_SELECTABLE_MODE: AggregationSelectable = { id: 'Match', text: 'MTR_COMMON_MATCH_VALUE' }
export const AGGREGATIONS_MAXIMUM_SELECTABLE_MODE: AggregationSelectable = { id: 'Maximum', text: 'MTR_COMMON_MAXIMUM' }
export const AGGREGATIONS_MAXIMUM_T1_SELECTABLE_MODE: AggregationSelectable = {
  id: 'Maximum1T',
  text: 'MTR_COMMON_MAXIMUM_1T'
}
export const AGGREGATIONS_MAXIMUM_T2_SELECTABLE_MODE: AggregationSelectable = {
  id: 'Maximum2T',
  text: 'MTR_COMMON_MAXIMUM_2T'
}

export const AGGREGATIONS_MODES: AggregationSelectable[] = [
  AGGREGATIONS_AVERAGE_SELECTABLE_MODE,
  AGGREGATIONS_ACCUMULATED_SELECTABLE_MODE,
  AGGREGATIONS_MATCH_SELECTABLE_MODE,
  AGGREGATIONS_MAXIMUM_SELECTABLE_MODE,
  AGGREGATIONS_MAXIMUM_T1_SELECTABLE_MODE,
  AGGREGATIONS_MAXIMUM_T2_SELECTABLE_MODE,
  AGGREGATIONS_COMPETITION_AVERAGE_SELECTABLE_MODE
]

export const COMMON_AGGREGATION_MODES: AggregationSelectable[] = [
  AGGREGATIONS_AVERAGE_SELECTABLE_MODE,
  AGGREGATIONS_ACCUMULATED_SELECTABLE_MODE,
  AGGREGATIONS_MAXIMUM_SELECTABLE_MODE,
  AGGREGATIONS_MAXIMUM_T1_SELECTABLE_MODE,
  AGGREGATIONS_MAXIMUM_T2_SELECTABLE_MODE,
  AGGREGATIONS_COMPETITION_AVERAGE_SELECTABLE_MODE
]
